/**
 * CustomerDetailPage — custom (non-generic) Customer detail page.
 *
 * Reuses the generic StandardDetailPage engine (schema-driven CRUD, save,
 * delete, rename, permissions, sidebar chrome, chat) and layers on:
 *  - a registered Shopify-style experience view (customerShopifyView) for the
 *    main column — every ERPNext Customer field, grouped into calm cards/tabs
 *  - a bespoke right sidebar (financial summary, order history, contact,
 *    address) via the opt-in `renderRightSidebar` prop
 *
 * This mirrors how the Sales Order page (SalesOrderDetailPage + OrderDetailSidebar)
 * works, without duplicating StandardDetailPage's ~900 lines of CRUD logic.
 */

import { StandardDetailPage } from "@/features/doc/StandardDetailPage";
import { CustomerDetailSidebar } from "./CustomerDetailSidebar";
import { AccountFinancialCard } from "./AccountFinancialCard";
import { CustomerHeaderAvatar } from "./CustomerHeaderAvatar";

export function CustomerDetailPage() {
  return (
    <StandardDetailPage
      forcedDoctype="Customer"
      headerMediaLayout="inline"
      headerMedia={({ formData, docName }) => (
        <CustomerHeaderAvatar customer={docName} formData={formData} />
      )}
      renderAboveMain={({ formData }) => <AccountFinancialCard formData={formData} />}
      renderRightSidebar={({ formData }) => <CustomerDetailSidebar formData={formData} />}
    />
  );
}
